import { render, staticRenderFns } from "./componenteInfoPrincipal.vue?vue&type=template&id=5fff8a86&lang=es"
import script from "./componenteInfoPrincipal.vue?vue&type=script&lang=js"
export * from "./componenteInfoPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports